<template>

  <form :data-url='apiUrl.DEPARTMENTS'
        method="POST"
        @submit="submitData"
        v-if="(isMailSettingExist || selectedUrl) && !preloader"
        ref="form">

    <app-form-group
        :label="$t('name')"
        type="text"
        v-model="formData.name"
        :placeholder="$placeholder('name')"
        :required="true"
        :error-message="errors.name"
    />

    <app-form-group-selectable
        type="search-select"
        :label="$t('manager')"
        list-value-field="full_name"
        :chooseLabel="$t('manager')"
        v-model="formData.manager_id"
        :required="true"
        :error-message="errors.manager_id"
        :fetch-url="`${apiUrl.TENANT_SELECTABLE_DEPARTMENT_USERS}?without=admin&employee=only&with_auth=yes`"
    />

    <!--                v-if="parentDeptEditPermission"-->
    <app-form-group-selectable
        type="select"
        :label="$t('parent_department')"
        list-value-field="name"
        v-model="formData.department_id"
        :chooseLabel="$t('parent_department')"
        :fetch-url="apiUrl.TENANT_SELECTABLE_DEPARTMENT_DEPARTMENTS"
        :error-message="errors.department_id"
    />

    <!--            <app-form-group-->
    <!--                :label="$t('location')"-->
    <!--                type="text"-->
    <!--                v-model="formData.location"-->
    <!--                :placeholder="$placeholder('location')"-->
    <!--            />-->

    <app-form-group
        :label="$t('working_shift')"
        type="select"
        v-model="formData.working_shift_id"
        :list="working_shifts"
        :error-message="$errorMessage(errors, 'working_shift_id')"
        @input="setCustomFieldType($event)"
    />

<!--    <app-form-group-->
<!--        type="select"-->
<!--        :label="$t('work_shift')"-->
<!--        :chooseLabel="$t('work_shift')"-->
<!--        v-model="formData.working_shift_id"-->
<!--        :required="true"-->
<!--        :error-message="errors.working_shift_id"-->
<!--        :list="working_shifts"-->
<!--    />-->
<!--        :fetch-url="`${TENANT_SELECTABLE_WORK_SHIFT}`"-->
<!--        :fetch-url="`${TENANT_SELECTABLE_WORK_SHIFT}`"-->
    <upcoming-working-shift-view
        v-if="this.formData.upcoming_working_shift.length"
        :working-shifts="this.formData.upcoming_working_shift"
        @workingShiftRemoved="getEditData(selectedUrl)"
    />

    <app-form-group
        :label="$t('description')"
        type="textarea"
        v-model="formData.description"
        :placeholder="$textAreaPlaceHolder('description')"
    />
  </form>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {TENANT_MAIL_CHECK_URL, TENANT_SELECTABLE_WORK_SHIFT} from "../../../../../common/Config/apiUrl";
import UpcomingWorkingShiftView from "./UpcomingWorkingShiftView";
import {axiosGet} from "../../../../../common/Helper/AxiosHelper";
const {WORKING_SHIFTS} = require("../../../../Config/ApiUrl");

export default {
  name: "DefaultDepartmentCreateEditModal",
  components: {UpcomingWorkingShiftView},
  mixins: [FormHelperMixins, ModalMixin],
  comments: {UpcomingWorkingShiftView},
  props: {
    makeDefault: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      TENANT_SELECTABLE_WORK_SHIFT,
      isMailSettingExist: false,
      WORKING_SHIFTS,
      working_shifts: [],
      formData: {
        name: '',
        manager_id: '',
        department_id: '',
        upcoming_working_shift: [],
        working_shift_id: '',
      },
    }
  },
  computed: {
    parentDeptEditPermission() {
      return this.selectedUrl ? this.formData.department_id : true;
    }
  },
  created() {
    this.checkMailSettings();
    this.getWorkingShifts();
  },
  methods: {
    validateForm(formData) {
      this.errors = {}; // Reset errors
      if (!formData.name.trim()) {
        this.errors.name = 'Name is required';
      }
      console.log(this.errors);

      // Check if the form is valid (no errors)
      this.isValid = Object.keys(this.errors).length === 0;
      return this.isValid;
    },
    getFormData() {
      return this.formData;
    },
    afterSuccess({data}) {
      this.formData = {};
      $('#department-modal').modal('hide');
      this.toastAndReload(data.message, 'department-table')
      this.$emit('input', false);
    },
    getWorkingShifts() {
      axiosGet(WORKING_SHIFTS)
          .then(({ data }) => {
            // Transform the data to key-value pairs (label and value)
            this.working_shifts = data.data.map(shift => ({
              value: shift.name,
              id: shift.id
            }));
          })
          .catch(error => {
            console.error('Error fetching working shifts:', error);
          });
    },
    afterSuccessFromGetEditData({data}) {
      this.preloader = false
      this.formData = data
      if (this.formData.department_id === null) {
        this.formData.department_id = ''
      }
      if (this.formData.manager_id === null) {
        this.formData.manager_id = ''
      }
      this.formData.working_shift_id = data.working_shift?.id
    },
    checkMailSettings() {
      this.preloader = true;
      axiosGet(TENANT_MAIL_CHECK_URL).then(response => {
        this.isMailSettingExist = !!response.data;
      }).finally(() => {
        this.preloader = false;
      });
    },
  }
}
</script>
